interface AILogoGradientIconProps extends React.SVGProps<SVGSVGElement> {
  'data-testid'?: string;
}

export const AI_LOGO_GRADIENT_ICON_TEST_ID = 'ai-logo-gradient-icon';

export default function AILogoGradientIcon({
  'data-testid': dataTestId,
  ...props
}: AILogoGradientIconProps): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid={dataTestId ?? AI_LOGO_GRADIENT_ICON_TEST_ID}
      {...props}
    >
      <path
        d="M15.5921 7.09234C17.0626 7.09234 18.2546 5.82121 18.2546 4.2532C18.2546 2.68519 17.0626 1.41406 15.5921 1.41406C14.1217 1.41406 12.9297 2.68519 12.9297 4.2532C12.9297 5.82121 14.1217 7.09234 15.5921 7.09234Z"
        stroke="url(#paint0_linear_51942_43923)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.67222 8.62945C8.14266 8.62945 9.33468 7.35832 9.33468 5.79031C9.33468 4.2223 8.14266 2.95117 6.67222 2.95117C5.20179 2.95117 4.00977 4.2223 4.00977 5.79031C4.00977 7.35832 5.20179 8.62945 6.67222 8.62945Z"
        stroke="url(#paint1_linear_51942_43923)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.27873 18.0042C5.8441 17.8458 6.99262 16.5355 6.84403 15.0776C6.69543 13.6197 5.30598 12.5663 3.74061 12.7248C2.17524 12.8833 1.02671 14.1936 1.17531 15.6514C1.3239 17.1093 2.71335 18.1627 4.27873 18.0042Z"
        stroke="url(#paint2_linear_51942_43923)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9783 13.513C23.6886 13.2742 23.2496 13.2199 22.7561 13.2042C22.617 13.2385 22.475 13.2671 22.3286 13.2814C21.7706 13.3371 21.237 13.2385 20.7722 13.0241C20.3906 12.8983 20.0492 12.6781 19.7996 12.2864C19.7967 12.2807 19.791 12.2735 19.7881 12.2664C19.4811 11.8904 19.276 11.4344 19.2243 10.9283C19.2186 10.874 19.2186 10.8211 19.2172 10.7668C19.1971 10.5981 19.2 10.4351 19.2416 10.2936C19.2444 10.285 19.2459 10.2779 19.2487 10.2707C19.4108 9.28716 20.1539 8.45657 21.1681 8.13206C21.5698 7.94335 21.9341 7.76895 22.168 7.41012C22.9283 6.24359 21.3431 3.80187 19.6647 3.8805C18.9547 3.91481 18.4755 4.92409 17.8343 5.77755C17.3609 6.56667 16.5346 7.09133 15.5922 7.09133C14.7501 7.09133 13.9998 6.67246 13.5121 6.022C13.5092 6.01914 13.5049 6.01486 13.5035 6.012C13.0473 5.48019 12.9311 4.92981 12.9369 4.39229C12.9354 4.34511 12.9297 4.29936 12.9297 4.25219C12.9297 3.99629 12.9641 3.74898 13.0244 3.5131C13.1248 2.84548 13.2353 2.22505 12.8895 1.71898C12.1995 0.708267 9.06799 0.618204 8.40238 2.39517C8.19724 2.94412 8.345 3.38586 8.58312 3.8176C8.84421 4.10351 9.04647 4.44947 9.17558 4.8326C9.42949 5.35868 9.54712 5.96339 9.16697 6.77825C8.97331 7.33578 8.62186 7.81183 8.16855 8.14064C7.77549 8.48659 7.40252 8.60811 7.03385 8.60239C6.91479 8.61954 6.79572 8.63098 6.67235 8.63098C5.9594 8.63098 5.31243 8.32934 4.83474 7.84185C4.43021 7.70747 4.00272 7.63314 3.53794 7.71748C0.522594 8.25929 0.495338 11.3114 1.89399 12.4923C2.20815 12.7567 2.73748 12.7896 3.33281 12.7982C3.46622 12.7667 3.60106 12.7396 3.74164 12.7253C4.39291 12.6595 5.01262 12.8053 5.52618 13.1013C5.53335 13.1041 5.54052 13.107 5.54769 13.1098C5.72557 13.1985 5.88481 13.32 6.02682 13.4644C6.47726 13.8804 6.77994 14.4408 6.84593 15.0784C6.91192 15.7288 6.71826 16.3507 6.34528 16.8525C6.24774 16.9954 6.13154 17.127 5.9967 17.2428C5.98379 17.2542 5.97088 17.2628 5.9594 17.2728C5.55917 17.6287 5.04848 17.8803 4.47324 17.9761C4.18491 18.1234 3.95108 18.355 3.79902 18.8739C3.11189 21.2227 5.67537 22.7924 7.15435 22.1719C7.41543 22.0619 7.61196 21.8674 7.78123 21.6316C7.78697 21.6072 7.7884 21.5829 7.79414 21.5586C8.15707 20.0333 9.61167 19.0712 11.0433 19.4086C11.5067 19.5186 11.9098 19.7531 12.2325 20.069C12.3545 20.1777 12.4592 20.2978 12.5395 20.4264C12.9111 20.9511 13.1004 21.6144 13.0473 22.3077C13.0818 22.8753 13.1076 23.46 13.4375 24.1776C14.1376 25.6987 18.6649 24.6651 18.4425 22.638C18.3837 22.1005 18.1269 21.633 17.8429 21.1784C17.2777 20.6194 16.9765 19.8818 16.9793 19.1498C16.9793 19.0869 16.9808 19.024 16.9865 18.9582C17.0209 18.5136 17.1687 18.0791 17.4412 17.6959C18.0165 16.8854 18.9977 16.518 19.9689 16.6466C20.2801 16.6666 20.5312 16.7481 20.7478 16.8625C20.94 16.9454 21.1265 17.0469 21.3044 17.1713C21.5024 17.3114 21.6745 17.4715 21.828 17.643C22.0446 17.7803 22.2856 17.8846 22.5955 17.9132C23.8406 18.0262 25.2507 14.558 23.9798 13.5087L23.9783 13.513Z"
        stroke="url(#paint3_linear_51942_43923)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3276 13.2796C20.7626 13.4383 19.3725 12.3847 19.2248 10.9265C19.0756 9.46836 20.2246 8.15887 21.7897 8.00019C23.3547 7.8415 24.7448 8.8951 24.8925 10.3533C25.0417 11.8114 23.8927 13.1209 22.3276 13.2796ZM22.0895 20.9807C22.9387 19.7842 22.5873 18.0801 21.3034 17.1752C20.0195 16.2689 18.2895 16.5047 17.4402 17.6999C16.591 18.8964 16.9425 20.6005 18.2264 21.5054C19.5103 22.4117 21.2403 22.1759 22.0895 20.9807ZM9.724 24.9321C11.1542 25.2709 12.6088 24.3088 12.9732 22.782C13.3361 21.2567 12.4711 19.7456 11.0409 19.4068C9.61068 19.068 8.15608 20.0301 7.79171 21.5569C7.42878 23.0822 8.29379 24.5933 9.724 24.9321Z"
        stroke="url(#paint4_linear_51942_43923)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_51942_43923"
          x1="18.2546"
          y1="2.20271"
          x2="12.1508"
          y2="3.96268"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#297BED" />
          <stop offset="0.5" stopColor="#BB42F3" />
          <stop offset="1" stopColor="#FD9476" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_51942_43923"
          x1="9.33468"
          y1="3.73982"
          x2="3.23084"
          y2="5.49979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#297BED" />
          <stop offset="0.5" stopColor="#BB42F3" />
          <stop offset="1" stopColor="#FD9476" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_51942_43923"
          x1="6.64971"
          y1="13.1711"
          x2="0.518251"
          y2="15.912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#297BED" />
          <stop offset="0.5" stopColor="#BB42F3" />
          <stop offset="1" stopColor="#FD9476" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_51942_43923"
          x1="24.4793"
          y1="4.32014"
          x2="-2.23565"
          y2="12.388"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#297BED" />
          <stop offset="0.5" stopColor="#BB42F3" />
          <stop offset="1" stopColor="#FD9476" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_51942_43923"
          x1="24.9056"
          y1="10.3477"
          x2="5.43477"
          y2="16.3981"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#297BED" />
          <stop offset="0.5" stopColor="#BB42F3" />
          <stop offset="1" stopColor="#FD9476" />
        </linearGradient>
      </defs>
    </svg>
  );
}
